module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_yoso_studio@2x-ccf703face43fe7471d3398a858fbf36.webp";